module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Radio 单选按钮")]), _vm._v(" "), _c('p', {}), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"form-group\">\n  <label class=\"label\">Gender:</label>\n\n  <!--Radio 最后的值是绑定在input[type=\"radio\"]上-->\n  <label class=\"input-control radio\">\n    <input type=\"radio\" name=\"gender\" checked>\n    <span class=\"check\"></span>\n    <span class=\"caption\">Male</span>\n  </label>\n<!--Radio-->\n  <label class=\"input-control radio\">\n    <input type=\"radio\" name=\"gender\">\n    <span class=\"check\"></span>\n    <span class=\"caption\">Female</span>\n  </label>\n</div>")])])]), _vm._v(" "), _c('h5', {
    staticClass: "fg-gray"
  }, [_vm._v("Disabled状态")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<label class=\"input-control radio\">\n  <input type=\"radio\" name=\"radio\" disabled>\n  <span class=\"check\"></span>\n  <span class=\"caption\">Disabled状态</span>\n</label>\n")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Gender:")]), _vm._v(" "), _c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "gender",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Male")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "gender"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Female")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "radio"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Select me")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "radio",
      "disabled": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Disabled状态")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69e610ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/radio.vue
// module id = 400
// module chunks = 1